export default "__VITE_ASSET__By3nlBo7__"